import { makeStyles } from 'tss-react/mui';

type StylesProps = {
  iconWidth?: number;
};

const useStyles = makeStyles<StylesProps>()((theme, { iconWidth }) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '32px 1fr',
    alignItems: 'center',
    gridGap: theme.spacing(3),
    padding: theme.spacing(3, 5),
    color: theme.palette.primary.main,
    border: 'none',
    background: 'transparent',
    width: '100%',
    textAlign: 'left',
    cursor: 'pointer',
    font: 'inherit',

    '&.active': {
      background: theme.palette.primary.main,
      color: theme.palette.getContrastText(theme.palette.primary.main),

      '& path, rect, circle': {
        fill: theme.palette.common.white,
        '&.inverted': {
          fill: theme.palette.primary.main,
        },
      },
      '& img': {
        filter: 'brightness(0) invert(1)',
      },
    },
  },
  icon: {
    width: `${iconWidth || 20}px`,
    maxHeight: '30px',
    margin: '0 auto',
    height: 'auto',
    display: 'block',
    '& path, rect, circle': {
      fill: theme.palette.primary.main,
      '&.inverted': {
        fill: theme.palette.common.white,
      },
    },
  },
  iconImage: {
    width: `${iconWidth || 32}px`,
    height: 'auto',
    display: 'block',
    '& path, rect, circle': {
      fill: theme.palette.primary.main,
      '&.inverted': {
        fill: theme.palette.common.white,
      },
    },
  },
  disabled: {
    color: theme.palette.text.disabled,
    cursor: 'default',
    '& path, rect, circle': {
      fill: theme.palette.text.disabled,
    },
    '& img': {
      opacity: 0.38,
    },
  },
  wrapper: {
    position: 'relative',
  },
  pointer: {
    position: 'absolute',
    top: '85%',
    left: '20%',
    animation: 'menuLinkPointerMove 1.25s infinite',
  },
  additionalTextBadge: {
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: 1.2,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    borderRadius: theme.spacing(20),
    padding: theme.spacing(1, 3.5),
    whiteSpace: 'nowrap',
    boxShadow: theme.shadows[4],
  },
  additionalTextBadgeMultiline: {
    whiteSpace: 'normal',
    textAlign: 'center',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    padding: theme.spacing(1.25, 4.5),
  },
  labelWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
}));

export default useStyles;
